"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCyberbetData = void 0;
const react_1 = require("react");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const useIntegrationData_1 = require("./useIntegrationData");
const useCyberbetData = () => {
    const { loaded, token, error, refreshToken, resetToken } = (0, useIntegrationData_1.useIntegrationData)({
        gameVendor: betweb_openapi_axios_1.VirtualGameVendor.Oddingg,
    });
    return (0, react_1.useMemo)(() => ({
        loaded,
        error,
        token,
        refreshToken,
        resetToken,
    }), [error, loaded, token, refreshToken, resetToken]);
};
exports.useCyberbetData = useCyberbetData;
//# sourceMappingURL=useCyberbetData.js.map